var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8113 0.453398C14.0697 0.182201 14.4888 0.182201 14.7472 0.453398L18.0563 3.92561C18.3147 4.19681 18.3147 4.63651 18.0563 4.90771L14.7472 8.37992C14.4888 8.65112 14.0697 8.65112 13.8113 8.37992C13.5528 8.10872 13.5528 7.66903 13.8113 7.39783L15.9905 5.1111L8.62548 5.1111L8.625 4.41666L8.62548 3.72222L15.9905 3.72222L13.8113 1.43549C13.5528 1.16429 13.5528 0.724595 13.8113 0.453398Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18678 12.5466C4.92832 12.8178 4.50929 12.8178 4.25083 12.5466L0.941777 9.07439C0.683325 8.80319 0.683325 8.36349 0.941778 8.09229L4.25083 4.62008C4.50929 4.34888 4.92832 4.34888 5.18678 4.62008C5.44523 4.89128 5.44523 5.33097 5.18678 5.60217L3.0075 7.8889L10.3726 7.8889L10.373 8.58334L10.3726 9.27778L3.0075 9.27778L5.18678 11.5645C5.44523 11.8357 5.44523 12.2754 5.18678 12.5466Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingSwitch);
export default __webpack_public_path__ + "react/media/billing-switch.dd8600bef62166b55e7f8f3db1c24410.svg";
export { ForwardRef as ReactComponent };